import styled from 'styled-components'

export const EmployeesWrapper = styled.div`
  @media (min-width: 1075px) {
    padding: 50px;
  }
  padding: 25px;
`

export const Title = styled.h1`
  font-size: 45px;
  color: var(--primary);
  margin-bottom: 3px;
  padding: 0;
  text-align: center;
`

export const Subtitle = styled.h2`
  font-size: 16px;
  color: #343a40;
  margin-bottom: 30px;
  padding: 0;
  text-align: center;
`

export const ListWrapper = styled.div`
  background-color: rgba(231, 234, 243, 0.2);
  border-radius: 5px;
  padding: 33px;
`

export const ListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`

export const Highlight = styled.span`
  color: var(--primary);
  font-size: 22px;
`

export const Amount = styled.span`
  font-size: 22px;
`

export const SwitchButton = styled.button<{ active?: boolean; left?: boolean }>`
  width: 86.5px;
  font-size: 12px;
  height: 31px;
  padding: 2px;
  white-space: nowrap;

  ${(props) =>
    props.active
      ? `
        background-color: var(--primary);
        color: #fff;
        border: none;
        `
      : `
        background-color: #FFF;
        color: rgba(0, 0, 0, 0.26);
        border: 1px solid rgba(0, 0, 0, 0.26);
    `}

  ${(props) =>
    props.left
      ? `border-top-left-radius: 2px; border-bottom-left-radius: 2px;`
      : `border-top-right-radius: 2px; border-bottom-right-radius: 2px;`}
`
